import { jsxs as m, Fragment as i, jsx as t } from "react/jsx-runtime";
import n from "./components/icon/Icon.js";
import "classnames";
import { ButtonLoadingIndicator as l } from "./components/button/ButtonLoadingIndicator.js";
import './assets/ButtonLinkBase.css';const r = "_link_1bmjd_9", c = "_button_1bmjd_10", b = "_loading_1bmjd_21", j = "_loader_1bmjd_25", u = "_disabled_1bmjd_55", y = "_fullwidth_1bmjd_85", p = "_active_1bmjd_101", f = "_text_1bmjd_108", x = "_small_1bmjd_112", g = "_medium_1bmjd_119", v = "_large_1bmjd_126", h = "_primary_1bmjd_133", w = "_secondary_1bmjd_142", k = "_tertiary_1bmjd_152", B = "_layered_1bmjd_165", L = "_inline_1bmjd_174", N = "_destructive_1bmjd_189", o = {
  link: r,
  button: c,
  loading: b,
  loader: j,
  disabled: u,
  fullwidth: y,
  "fullwidth-mobile": "_fullwidth-mobile_1bmjd_85",
  active: p,
  text: f,
  small: x,
  medium: g,
  large: v,
  primary: h,
  secondary: w,
  tertiary: k,
  layered: B,
  inline: L,
  destructive: N,
  "secondary-on-accent": "_secondary-on-accent_1bmjd_195"
}, C = ({ children: _, trailingIcon: e, leadingIcon: d, loading: s, suppressHydrationWarning: a }) => /* @__PURE__ */ m(i, { children: [
  s && /* @__PURE__ */ t(l, { className: o.loader }),
  !!d && /* @__PURE__ */ t(n, { name: d }),
  !!_ && /* @__PURE__ */ t("span", { className: o.text, suppressHydrationWarning: a, children: _ }),
  !!e && /* @__PURE__ */ t(n, { name: e })
] });
export {
  C as B,
  o as s
};
